import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import VarahaFestivalPopup from "./VarahaPopup.jsx";
import {
  clearPopupSession,
  isPopupClosedThisSession,
  setPopupClosedThisSession,
} from "../utils/popupUtils";
import { addNewsletterSignup } from "../firebase/firestore";

const PopupWrapper = () => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  const [shouldShowPopup, setShouldShowPopup] = useState(false);

  // Check if we're on auth pages
  const isAuthPage =
    location.pathname === "/auth" || location.pathname === "/auth-test";

  // Check if we're on admin pages
  const isAdminPage = location.pathname.startsWith("/admin");

  // Check if popup was closed in this session
  // eslint-disable-next-line no-unused-vars
  const SESSION_KEY = "vs_popup_closed_this_session";

  // Clear session storage on page refresh (so popup can show again)
  useEffect(() => {
    const handleBeforeUnload = () => {
      clearPopupSession();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    // Wait for authentication to be fully initialized
    if (loading) {
      if (process.env.NODE_ENV === 'development') {}
      return;
    }

    // Don't show popup if:
    // 1. User is on auth pages
    // 2. User is on admin pages
    // 3. User is logged in
    // 4. Popup was already closed in this session
    const popupClosedThisSession = isPopupClosedThisSession();

    if (process.env.NODE_ENV === 'development') {}

    if (isAuthPage || isAdminPage || currentUser || popupClosedThisSession) {
      if (process.env.NODE_ENV === 'development') {}
      setShouldShowPopup(false);
    } else {
      if (process.env.NODE_ENV === 'development') {}
      setShouldShowPopup(true);
    }
  }, [isAuthPage, isAdminPage, currentUser, loading, location.pathname]);

  const handlePopupClose = async (data) => {
    // If data is provided (form submission), save it to newsletter
    if (data && data.email && data.whatsapp) {
      try {
        await addNewsletterSignup({
          email: data.email,
          whatsapp: data.whatsapp,
          countryCode: data.countryCode || "+91",
          fullPhone: `${data.countryCode || "+91"}${data.whatsapp}`,
          source: "popup",
          userId: null, // Not logged in
        });
        alert("Thank you for joining Varaha Family! 🎉");
      } catch (error) {
        // Still close popup even if save fails
      }
    }
    
    // Mark popup as closed for this session
    setPopupClosedThisSession();
    setShouldShowPopup(false);
  };

  // Handle escape key to close popup
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && shouldShowPopup) {
        handlePopupClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [shouldShowPopup]);

  // Don't render popup if it shouldn't show
  if (!shouldShowPopup) {
    return null;
  }

  return (
    <VarahaFestivalPopup
      scheduleMs={[5000, 30000, 60000]}
      cooldownDays={3}
      bypassCooldown={true}
      debug={true}
      onSubmit={handlePopupClose}
    />
  );
};

export default PopupWrapper;
